<template>
    <div>
        <el-dialog
            class="resetStylepb"
            append-to-body
            :title="config.dialogName"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :before-close="handleBeforeClose"
            width="1200px"
        >
            <div class="fs0 df">
                <div class="left">
                    <div>
                        <el-select v-model="Signs" @change="resetPost" size="small" class="w120">
                            <el-option
                                v-for="item in typeData"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <el-input
                            v-model="productName"
                            class="name-input"
                            size="small"
                            :placeholder="searchType === 2 ? '请输入商品ID' : '请输入标题'"
                        />
                        <el-button class="search-btn" type="primary" size="small" @click="resetPost">搜索</el-button>
                    </div>
                    <el-table
                        v-loading="tableLoading"
                        :data="tableData"
                        height="475"
                        class="resetStyle list-table"
                        :empty-text="emptyText"
                    >
                        <el-table-column label="图片" width="84">
                            <template slot-scope="scope">
                                <div class="image-box">
                                    <el-image
                                        style="width: 64px; height: 64px; background-color: #eee"
                                        :src="scope.row.img || defaultImg"
                                        fit="contain"
                                    />
                                    <p v-if="scope.row.Processing" class="processing-tag">工厂</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="标题">
                            <template slot-scope="scope">
                                <a href="javascript:;" class="title">{{ scope.row.name }}</a>
                                <div class="other">
                                    <span
                                        >价格：{{ getStart(scope.row.priceStart) }} ~
                                        {{ getEnd(scope.row.priceEnd) }}元</span
                                    >
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="选择" width="100">
                            <template slot-scope="scope">
                                <span
                                    v-if="canIOperate && typeof canIOperate === 'function' && !canIOperate(scope.row)"
                                    class="orangeFont"
                                    >{{ disableOperateText }}</span
                                >
                                <template v-else>
                                    <el-button
                                        v-if="disableSelectPro === null"
                                        type="primary"
                                        size="small"
                                        :disabled="scope.row.disabled"
                                        @click="selectProduct(scope.row, scope.$index)"
                                        >{{ scope.row.disabled ? '已' : '' }}{{ selectBtnName }}</el-button
                                    >
                                    <el-button
                                        v-else
                                        type="primary"
                                        size="small"
                                        :disabled="scope.row.disabled || matchedPro[scope.row.productIdStr]"
                                        @click="selectProduct(scope.row, scope.$index)"
                                        >{{
                                            matchedPro[scope.row.productIdStr]
                                                ? disableSelectPro.MatchedBtnName
                                                : scope.row.disabled
                                                ? `已${selectBtnName}`
                                                : selectBtnName
                                        }}321</el-button
                                    >
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="right">
                    <div class="prompt">
                        您已选择{{ tableDataRight.length }}个商品<!--<span>(点击图片可以替换主图)</span>-->
                    </div>
                    <ul>
                        <li v-for="(item, index) in tableDataRight" :key="item.productIdStr" class="dfc">
                            <el-image
                                style="
                                    width: 64px;
                                    height: 64px;
                                    margin-right: 15px;
                                    background-color: #fff;
                                    cursor: pointer;
                                "
                                :src="item.img || defaultImg"
                                fit="contain"
                            />
                            <div>
                                <a>{{ item.name }}</a>
                                <p class="dfc mt5">
                                    <span>价格：</span
                                    ><span>{{ getStart(item.priceStart) }} ~ {{ getEnd(item.priceEnd) }}元</span>
                                </p>
                            </div>
                            <i
                                :style="{ marginLeft: '35px' }"
                                style="margin-left: 5px; cursor: pointer"
                                class="el-icon-delete"
                                @click="delChoose(item, index)"
                            ></i>
                        </li>
                    </ul>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <div style="display: flex; align-items: center">
                    <el-pagination
                        class="pagination"
                        :page-size="query.PageSize"
                        :pager-count="5"
                        :current-page.sync="query.PageIndex"
                        background
                        layout="prev, pager, next,total, jumper"
                        :total="total"
                        @current-change="currentChange"
                    />
                    <el-button type="primary" size="small" style="margin-left: 10px" @click="allChooseBtn"
                        >本页全选</el-button
                    >
                </div>
                <div>
                    <el-button type="primary" size="small" @click="sureChoose">{{ sureBtnText }}</el-button>
                    <el-button size="small" @click="emptyBtn">{{ cancelBtnText }}</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import configUrl from '@/common/config.js';
import { cloneDeep } from 'lodash';
let options;
const productInfo = {};
export default {
    name: 'ProductChoose',
    props: {
        selectBtnName: { type: String, default: '选择' },
        sureBtnText: { type: String, default: '确 定' },
        cancelBtnText: { type: String, default: '清 空' },
    },
    data() {
        return {
            typeData: [
                {
                    value: 0,
                    label: '售卖中',
                },
                {
                    value: 1,
                    label: '已下架',
                },
            ],
            config: {
                dialogName: '选择导入已发信息',
                showStar: false,
                optionalNum: 'multi', // 默认：多选 multi  ||  填写数字为具体可选数量
            }, // 外部可配置集合
            dialogVisible: false,
            imgPrefix: configUrl.alicdn,
            defaultImg: configUrl.defaultImg,
            Status: 'published',
            productName: '',
            tableLoading: false,
            emptyText: ' ', // 无数据的提示语
            tableData: [],
            categoryId: '',
            total: 0,
            tableDataRight: [],
            query: {
                PageIndex: 1,
                PageSize: 15,
            },
            disableSelectPro: null,
            matchedPro: {},
            editMode: false,
            searchByOrder: false,
            orderTypeList: [
                { label: '全部产品', value: '' },
                { label: '现货产品', value: 'isSupportStock' },
                { label: '找工厂产品', value: 'isFactoryMemProcessingOffer' },
            ],
            searchType: 2,
            searchList: [
                { label: '产品ID', value: 2 },
                { label: '标题', value: 1 },
            ],
            maxSearchIds: 15, //最多搜索产品id个数
            Signs: 0,
            warningTextMap: {
                min: '最少要选择$min个产品',
                max: '最多不能大于$max个产品',
            },
        };
    },
    mounted() {
        // this.postList();
    },
    methods: {
        getStart(specPrices) {
            if (specPrices) {
                specPrices = (specPrices / 100).toFixed(2);
                return specPrices;
            }
        },
        getEnd(priceEnd) {
            if (priceEnd) {
                priceEnd = (priceEnd / 100).toFixed(2);
                return priceEnd;
            }
        },
        show(data) {
            options = {
                dialogName: '选择导入已发信息',
                showStar: false,
                optionalNum: 'multi', // 默认：多选 multi  ||  填写数字为具体可选数量
                minNum: 1, // 最小选择的数量
                pageIndex: 1,
                categoryId: '', // 类目Id
                renderArr: [],
                editMode: false,
                disableSelectPro: null,
                callBack: undefined,
                searchByOrder: false,
                Signs: data.productionPosition,
                canIOperate: () => {
                    return true;
                },
                disableOperateText: '无法选择当前商品',
                warningTextMap: {
                    min: '最少要选择$min个产品',
                    max: '最多不能大于$max个产品',
                },
            };
            options = Object.assign(options, data);
            this.matchedPro = {};
            this.Status = data.Status || 'published';
            this.config.dialogName = options.dialogName;
            this.config.showStar = options.showStar;
            this.config.optionalNum = options.optionalNum;
            this.editMode = !!options.editMode;
            this.disableSelectPro = options.disableSelectPro || null;
            this.categoryId = options.categoryId;
            this.searchByOrder = options.searchByOrder;
            this.Signs = options.searchByOrder && !options.Signs ? 'isSupportStock' : options.Signs;
            this.canIOperate = options.canIOperate;
            this.disableOperateText = options.disableOperateText;
            this.warningTextMap = Object.assign(
                {
                    min: '最少要选择$min个产品',
                    max: '最多不能大于$max个产品',
                },
                options.warningTextMap
            );

            // if(this.query.PageIndex != options.pageIndex){
            //     this.query.PageIndex = options.pageIndex
            //     this.postList();
            // }
            this.currentChange(options.pageIndex);
            if (options.renderArr && options.renderArr.length > 0) {
                options.renderArr = options.renderArr.map((v) => {
                    if (!v.Price) {
                        // 补充价格字段
                        v.Price =
                            v.SaleInfo && v.SaleInfo.priceRanges && v.SaleInfo.priceRanges.length > 0
                                ? v.SaleInfo.priceRanges[v.SaleInfo.priceRanges.length - 1].price
                                : 0;
                    }
                    return v;
                });
                this.tableDataRight = options.renderArr;
            } else {
                this.tableDataRight = [];
            }
            // if (this.tableData.length) {
            //   let tableData = this.tableData;
            //   let renderArr = [];
            //   if (options.renderArr && options.renderArr.length > 0) {
            //     renderArr = options.renderArr.map((o) => o.productIdStr);
            //   }
            //   this.tableData = tableData.map((v) => {
            //     return {
            //       ...v,
            //       disabled: renderArr.length ? renderArr.includes(v.productIdStr) : false,
            //       Price:
            //         v.SaleInfo && v.SaleInfo.priceRanges && v.SaleInfo.priceRanges.length > 0
            //           ? v.SaleInfo.priceRanges[v.SaleInfo.priceRanges.length - 1].price
            //           : "面议",
            //     };
            //   });
            // }

            this.dialogVisible = !this.dialogVisible;
        },
        selectProduct(item, index) {
            if (this.config.optionalNum === 'multi') {
                if (this.editMode) {
                    // 编辑模式从尾部添加
                    this.tableDataRight.push(cloneDeep(item));
                } else {
                    // 非编辑模式从头部添加
                    this.tableDataRight.unshift(cloneDeep(item));
                }

                this.tableData[index].disabled = true;
            } else {
                if (this.tableDataRight.length >= Number(this.config.optionalNum)) {
                    this.$message({
                        message: this.warningTextMap.max.replace('$max', this.config.optionalNum),
                        type: 'warning',
                        showClose: true,
                    });
                    return;
                }
                if (this.editMode) {
                    // 编辑模式从尾部添加
                    this.tableDataRight.push(cloneDeep(item));
                } else {
                    // 非编辑模式从头部添加
                    this.tableDataRight.unshift(cloneDeep(item));
                }
                this.tableData[index].disabled = true;
            }
        },
        move(flag, index) {
            // flag:  0:下移   1:上移
            let first = index;
            if (flag) {
                // 上移
                if (index === 0) {
                    this.$message.warning('已经是第一个了！');
                    return;
                }
                first -= 1;
            } else {
                // 下移
                // eslint-disable-next-line no-lonely-if
                if (index === this.tableDataRight.length - 1) {
                    this.$message.warning('已经是最后一个了！');
                    return;
                }
            }
            const arr = this.tableDataRight.map((v, i) => {
                if (i === first) {
                    return this.tableDataRight[i + 1];
                } else if (i === first + 1) {
                    return this.tableDataRight[first];
                } else {
                    return v;
                }
            });
            this.tableDataRight = arr;
        },
        delChoose(item, index) {
            const tableDataRight = this.tableDataRight;
            const tableData = this.tableData;
            for (let j = 0; j < tableData.length; j++) {
                if (tableData[j].productIdStr === item.productIdStr) {
                    tableData[j].disabled = false;
                    break;
                }
            }
            tableDataRight.splice(index, 1);
        },
        currentChange(index) {
            this.query.PageIndex = index;
            this.postList();
        },
        sureChoose() {
            if (this.tableDataRight.length < options.minNum) {
                this.$message({
                    message: this.warningTextMap.min.replace('$min', options.minNum),
                    type: 'warning',
                    showClose: true,
                });
                return;
            }
            const arr = cloneDeep(this.tableDataRight);
            arr.forEach((item) => {
                if (item.Price && item.Price !== '面议') {
                    item.SaleInfo.priceRanges[item.SaleInfo.priceRanges.length - 1].price = Number(item.Price);
                }
                delete item.Price;
            });
            options.callBack &&
                options.callBack({
                    data: arr,
                    pageIndex: this.query.PageIndex,
                });
            this.productName = '';
            this.dialogVisible = false;
        },
        emptyBtn() {
            this.tableDataRight = [];
            for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].disabled = false;
            }
        },
        resetPost() {
            this.query.PageIndex = 1;
            this.postList();
        },
        getSearchData() {
            let status;
            let checkStatus;
            if (this.Signs === 0) {
                status = 0;
                checkStatus = [3];
            } else if (this.Signs === 1) {
                status = 1;
                checkStatus = [1, 7];
            } else if (this.Signs === 2) {
                status = 0;
                checkStatus = [4];
            } else if (this.Signs === 3) {
                status = 0;
                checkStatus = [1];
            }
            return {
                status,
                checkStatus,
            };
        },
        postList() {
            this.tableLoading = true;
            this.$ajax
                .post('api/tiktok/Product/SearchListV2', {
                    pageIndex: this.query.PageIndex,
                    pageSize: this.query.PageSize,
                    productIdStr: this.productName,
                    ...this.getSearchData(),
                })
                .then((res) => {
                    this.tableLoading = false;
                    const tableDataRight = this.tableDataRight;
                    if (res.result.list.length) {
                        res.result.list.forEach((item) => {
                            item.disabled = false;
                            if (tableDataRight.length > 0) {
                                for (let i = 0; i < tableDataRight.length; i++) {
                                    if (tableDataRight[i].productIdStr === item.productIdStr) {
                                        item.disabled = true;
                                    }
                                }
                            }
                        });
                    }
                    this.tableData = res.result.list;
                    this.total = res.result.totalCount;
                    if (!res.result.list || (res.result.list.length === 0 && this.productName === '')) {
                        this.emptyText = '暂无数据';
                    } else {
                        this.emptyText = '暂无搜索结果';
                    }
                });
        },
        handleBeforeClose() {
            this.productName = '';
            this.dialogVisible = false;
        },

        allChooseBtn() {
            if (this.config.optionalNum === 'multi') {
                const arr = [];
                if (this.disableSelectPro !== null) {
                    // 本页全选时要过滤 被禁止选择的 按钮
                    for (let i = 0; i < this.tableData.length; i++) {
                        const item = this.tableData[i];
                        if (item.disabled || this.matchedPro[item.productIdStr] || !this.canIOperate(item)) {
                            continue;
                        } else {
                            arr.push(cloneDeep(item));
                            item.disabled = true;
                        }
                    }
                } else {
                    for (let i = 0; i < this.tableData.length; i++) {
                        const item = this.tableData[i];
                        if (!item.disabled && this.canIOperate(item)) {
                            arr.push(cloneDeep(item));
                            item.disabled = true;
                        }
                    }
                }
                if (arr.length === 0) {
                    return;
                }
                if (this.editMode) {
                    // 编辑模式从尾部添加
                    this.tableDataRight = this.tableDataRight.concat(arr);
                } else {
                    // 非编辑模式从头部添加
                    this.tableDataRight = [...arr.reverse(), ...this.tableDataRight];
                }
            } else {
                if (this.tableDataRight.length >= Number(this.config.optionalNum)) {
                    this.$message({
                        message: this.warningTextMap.max.replace('$max', this.config.optionalNum),
                        type: 'warning',
                        showClose: true,
                    });
                    return;
                }
                for (let i = 0; i < this.tableData.length; i++) {
                    if (this.tableDataRight.length >= Number(this.config.optionalNum)) {
                        this.$message({
                            message: this.warningTextMap.max.replace('$max', this.config.optionalNum),
                            type: 'warning',
                            showClose: true,
                        });
                        return;
                    }
                    if (!this.tableData[i].disabled && this.canIOperate(this.tableData[i])) {
                        if (this.editMode) {
                            // 编辑模式从尾部添加
                            this.tableDataRight.push(this.tableData[i]);
                        } else {
                            // 非编辑模式从头部添加
                            this.tableDataRight.unshift(this.tableData[i]);
                        }
                        this.tableData[i].disabled = true;
                    }
                }
            }
        },
        matchPro() {
            const tableData = cloneDeep(this.tableData);
            for (let i = 0, len = tableData.length; i < len; i++) {
                const { SaledCount } = productInfo[tableData[i].productIdStr];
                tableData[i].SaledCount = SaledCount;
            }
            this.tableData = tableData;
        },
    },
};
</script>

<style scoped lang="scss">
.el-icon-delete {
    font-size: 16px;
}
.image-box {
    position: relative;
    .processing-tag {
        position: absolute;
        right: 0;
        top: 0;
        background: #388eef;
        padding: 0 3px;
        font-size: 12px;
        color: #fff;
        z-index: 1;
        line-height: 20px;
        height: 20px;
    }
}
.left {
    display: inline-block;
    vertical-align: top;
    width: 650px;
    border-right: 1px solid #ebecf1;
    padding-right: 15px;
    .name-input {
        width: 230px;
        margin-left: 10px;
    }
    .search-btn {
        margin-left: 14px;
        font-size: 14px;
        border: none;
    }
    .list-table {
        width: 100%;
        margin-top: 20px;
    }
    .img {
        max-width: 64px;
        max-height: 64px;
    }
    .title {
        display: block;
        text-align: left;
    }
    .other {
        text-align: left;
    }
    .title:hover {
        color: #409eff;
    }
    .pagination {
        margin-top: 10px;
        text-align: center;
    }
}
.right {
    display: inline-block;
    vertical-align: top;
    // width: 510px;
    flex: 1;
    padding-left: 15px;
    .prompt {
        color: #4c4b4b;
        font-weight: bold;
        font-size: 14px;
        span {
            font-weight: 500;
        }
    }
    ul {
        height: 509px;
        margin-top: 5px;
        overflow-y: auto;
        li {
            position: relative;
            padding: 10px 15px;
            img {
                width: 64px;
                height: 64px;
                margin-right: 15px;
                cursor: pointer;
            }
            div {
                display: inline-block;
                vertical-align: top;
                width: 320px;
                span,
                a {
                    display: block;
                    font-size: 12px;
                    color: #4c4b4b;
                    line-height: 1.5;
                    padding: 2px 0;
                }
            }
            .icon-qingchu {
                position: absolute;
                top: 0%;
                right: 13px;
                font-size: 18px;
                line-height: 1;
                margin-top: 33px;
                cursor: pointer;
                color: #c5c5c5;
            }
        }
        .icon-qingchu {
            position: absolute;
            top: 50%;
            right: 13px;
            font-size: 18px;
            margin-top: -9px;
            cursor: pointer;
            color: #c5c5c5;
        }
    }
    li:nth-child(odd) {
        background-color: #f2f2f2;
    }
}
.dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #fff;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    background-color: #e8e8e8;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 8px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #bbb;
}
</style>

<style lang="scss">
.edit-main-img {
    width: 320px;
    .el-message-box__header {
        .el-message-box__header {
            font-size: 14px;
        }
    }
    .el-message-box__btns {
        text-align: center;
        padding: 15px 0 10px;
    }
    .el-message-box__content {
        padding: 0;
    }
}
</style>
